const RS = {
  ibanLength: 22,
};
export { RS };
